export default __webpack_public_path__ + "static/media/gallery - cover_02.49ac3258.jpg";